import icon from './oney.svg';

import type { Provider } from '../providers'

export default {
    key: 'oney',
    name: 'Oney',
    color: '#8bbc06',
    icon,
} satisfies Provider;
